// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"617bb1d9","533":"893c6ecc","732":"ba95c908","750":"3ad8a03c","977":"5a6f77b0"}[chunkId] + ".chunk.js";
};